const getTableActionApplication = () => {
    return `
        import TableAction from '../../../TableUtils/TableAction'; //Import TableAction component from your src folder

    `;
}

export default getTableActionApplication;
